
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.4 3v2h5.2V3h.8v2H16v12H4V5h2.6V3h.8zM4.8 5.8h10.4v2.3H4.8V5.8zm10.4 3.1v7.3H4.8V8.9h10.4z","fill":"#101010"}})])
      }
    
      }
    